<template>
  <div>
    <base-header v-once pageName="일정관리" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
      <ul class="tab tab-fix">
        <li><button type="button" @click="goMy()">내 일정</button></li>
        <li><button type="button" class="current">본사 일정</button></li>
      </ul>

      <div class="calendar" v-if="'M' == calendarInfo.wOrM">
        <p>
          <button type="button" class="prev" @click="goPreMonCalendar">이전</button>
          <strong>{{calendarInfo.y}}년 {{calendarInfo.intM}}월</strong>
          <button type="button" class="next" @click="goNextMonCalendar">다음</button>
        </p>
        <ul class="week">
          <li>일</li>
          <li>월</li>
          <li>화</li>
          <li>수</li>
          <li>목</li>
          <li>금</li>
          <li>토</li>
        </ul>
        <ul>
          <li v-for="(value, index) in arrayMonthDate" v-bind:key="index" :class="{ this: checkThisMon(value), current:calendarInfo.searchDay == value, today:calendarInfo.today == value}" >
            {{ getOnlyDate(value) }}
            <span v-if="getScheduleCount(value) > 0"><i v-for="(value, index) in getScheduleCount(value)" v-bind:key="index"></i></span>
          </li>
        </ul>
      </div>
      <div class="ep-schedule">
        <!--h4>0000.00.00 (월)</h4>
        <p class="info">
          <span>오늘시작 <em>3</em>건</span>
          <span>종료임박 <em>4</em>건</span>
        </p-->
        <ul>
          <li v-for="(hdSchedule,index) in hdScheduleList" v-bind:key="index" @click="goPage(index)">
            <em class="event">{{ hdSchedule.cdNm }}</em>
            <div>
              <span>{{ getFormattedDate(hdSchedule.sttDt, '.') }} ~ {{ getFormattedDate(hdSchedule.endDt, '.') }}</span>
              <p>{{ hdSchedule.title }}</p>
            </div>
          </li>
          <!-- 검색 결과 실패시-->
          <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
          <div slot="no-more"></div>
          <div slot="no-results">
           <li class="dataNone">등록된 일정이 없습니다.</li>
          </div>
          </infinite-loading>
        </ul>

        <!--button type="button" class="register">일정등록</button-->
      </div>
    </section>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "HdScheduleList",
  components: {
    InfiniteLoading
  },
  data() {
    return {
			tot:0,
			offset: 0,	 //현재 가지고있는 갯수
			size : 0,	//한번에 가져오는 수
      hdSchedulelUrl:'http://ksos.kyowon.co.kr/#/comn/schedule',
      calendarInfo:{
        y: "",
        m: "",
        intM: 0,
        today: "",
        searchDay: "",
        wOrM: "M",
        selectedWeekNum: 0,
        totalWeekNum: 0
      },
      arrayMonthDate:[
      ],
      arrayWeekDate:[
      ],
      searchDayForView: "",
      params: {
        searchMon: "",
        searchDay: ""
      },
      hdScheduleCountList: [
        {
          monthDate: "",
          cnt: 0
        }
      ],
      hdScheduleList: [
        {
          seq: 0,
          sttDt: "",
          endDt: "",
          title: "",
          titleSmp: "",
          cdNm: ""
        }
      ]
    };
  },
  methods: {
    infiniteHandler: function($state) {
      //console.log("SCROLL");
      var that = this;
      var parameters = {
        searchMon: this.params.searchMon,
        offset: this.offset,
        size: this.size
      };
      this.$api.myschedule.getHdScheduleList(parameters)
        .then(function(res) {
          console.log( "HdScheduleList.vue <api.myschedule.getHdScheduleList.response> hdScheduleList",  res.hdScheduleList );
          that.tot = res.totalCount;
          var list = res.hdScheduleList;
          if (list.length) {
            that.offset += that.size;
            that.hdScheduleList = that.hdScheduleList.concat(list);
            $state.loaded();
            if (list.length < that.size) {
              $state.complete();
            }
          } else {
            $state.complete();
          }
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    goMy(){ // 내일정 페이지로 연결
      this.$router.push('/mySchedule/myScheduleList');
    },
    getFormattedDate(dd,Type){ // 날짜(dd)를 구분자(Type)로 구별해서 보여준다.
        if(dd){
            return dd.substr(0,4) + Type + dd.substr(4,2) + Type + dd.substr(6,2);
        }
    },
    goPage(index) { // 해당 본사일정을 팝업으로 연결하기 였으나, 현재는 막았음
      console.log("HdScheduleList.vue goPage index: "+index);
      //console.log("HdScheduleList.vue goPage session.userId: "+this.$store.state.session.userId);
      //var params = "seq=" +this.hdScheduleList[index].seq;
     // console.log("HdScheduleList.vue goPage params: "+params);
      //this.$utils.nativeIf.outbound.newPage(this.hdSchedulelUrl);
    },
    getHdScheduleCountList() { // 해당 월의 각 날짜별 본사일정 카운트 조회
      var that = this;

      console.log( "HdScheduleList.vue getHdScheduleCountList that.params", that.params );

      this.$api.myschedule.getHdScheduleCountList(that.params)
        .then(function(res) {
          console.log( "HdScheduleList.vue <api.myschedule.getHdScheduleCountList.response>", res.hdScheduleCountList  );
          //console.log( "HdScheduleList.vue <api.myschedule.getHdScheduleCountList.response> length", res.hdScheduleCountList.length );
          that.hdScheduleCountList = res.hdScheduleCountList;
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
    },
    getHdScheduleList() { // 해당 월의 본사일정 목록조회
      this.tot = 0;
			this.offset = 0
			this.size = 10
      this.hdScheduleList = [];
      this.$refs.InfiniteLoading.stateChanger.reset();
    },
    popView: function (index){ // 상세보기 화면으로 
          console.log( "HdScheduleList.vue popView index",  index );
    },
    getOnlyDate: function(d) { // 날짜만 리턴하기
      //console.log("HdScheduleList.vue getOnlyDate d", d);
      return d.substr(6,2) * 1;
    },
    checkThisMon: function(d) { // 조회한 달과 같은 달인지 체크.
      //console.log("HdScheduleList.vue checkThisMon d", d);
      if(this.calendarInfo.y + this.calendarInfo.m == d.substr(0,6)){
        return true;
      }
      return false;
    },
    getScheduleCount: function(d) { // 해당일의 스케줄 갯수.
      // console.log("HdScheduleList.vue getScheduleCount d", d);
      // console.log(this.hdScheduleCountList.find(c => c.monthDate === d));
      var find = this.hdScheduleCountList.find(c => c.monthDate === d);
      if(find){ 
        return find.cnt;
      }
      return 0;
    },
    goPreMonCalendar: function() { // 이전 월 달력
			var firstDayOfPreMon = new Date(this.calendarInfo.y, this.calendarInfo.intM - 2, 1);
      console.log("HdScheduleList.vue goPreMonCalendar firstDayOfPreMon", firstDayOfPreMon);
      var yearOfPreMon = firstDayOfPreMon.getFullYear();
			var monthOfPreMon = firstDayOfPreMon.getMonth() + 1;
      var preMon = yearOfPreMon + this.$utils.stringUtil.pad(monthOfPreMon);

      this.calculateMonthDateArray(preMon);
    },
    goNextMonCalendar: function() { // 이후 월 달력
			var firstDayOfNextMon = new Date(this.calendarInfo.y, this.calendarInfo.intM, 1);
      //console.log("HdScheduleList.vue goNextMonCalendar firstDayOfNextMon", firstDayOfNextMon);

      var yearOfNextMon = firstDayOfNextMon.getFullYear();
			var monthOfNextMon = firstDayOfNextMon.getMonth() + 1;
      var nextMon = yearOfNextMon + this.$utils.stringUtil.pad(monthOfNextMon);

      this.calculateMonthDateArray(nextMon);
    },
    goOtherWeekCalendar: function(type) { // 이전/이후 주 달력 이동
			// console.log("goOtherWeekCalendar type:" + type);
			// console.log("goOtherWeekCalendar this.calendarInfo.selectedWeekNum:" + this.calendarInfo.selectedWeekNum);
      var postWeekNum = 0;
      if("PRE" == type){
        postWeekNum = this.calendarInfo.selectedWeekNum - 1;
      }else{
        postWeekNum = this.calendarInfo.selectedWeekNum + 1;
      }
			// console.log("goOtherWeekCalendar this.calendarInfo.totalWeekNum:" + this.calendarInfo.totalWeekNum);
			// console.log("goOtherWeekCalendar postWeekNum:" + postWeekNum);
      
      if(postWeekNum > 0 && postWeekNum <= this.calendarInfo.totalWeekNum){
        var weekStartDate = this.$utils.calendar.getWeekStartByWeekNum(this.calendarInfo.y, this.calendarInfo.intM, postWeekNum);// 넘긴 년도, 월, 주 차수의 첫날 조회.
        var arrayDate = this.$utils.calendar.getWeekDateArray(weekStartDate); // 넘긴 날짜(Date type)로 시작하는 7일 날짜 배열 조회.
        // console.log("arrayDate:" + arrayDate);
        // console.log("-------------------------------");

        this.calendarInfo.selectedWeekNum = postWeekNum;
        this.arrayWeekDate = arrayDate;
      }
    },
    changeCalendarType: function() { // 월 달력/ 주 달력 보이기 변경.
      var wOrM = this.calendarInfo.wOrM;
      if("W" == wOrM){ 
        this.calendarInfo.wOrM = "M";
      }else{
        this.calculateWeekDateArray();
        this.calendarInfo.wOrM = "W";
      }
    },
    calculateMonthDateArray : function (selectedMon) { // 해당 월의 날짜 목록 조회 및 일정 카운트 조회      
      var y = selectedMon.substr(0,4);
      var m = selectedMon.substr(4,2);
      
      var arrayDate = this.$utils.calendar.calculateMonthDateArray(selectedMon);
      
			// console.log("arrayDate:" + arrayDate);
			// console.log("-------------------------------");

      this.arrayMonthDate = arrayDate;
      this.calendarInfo.y = y;
      this.calendarInfo.m = m;
      this.calendarInfo.intM = m * 1;
      
      this.params.searchMon = selectedMon;

      this.getHdScheduleCountList(); // 선택한 달의 각 날짜별 일정 카운트 조회
      this.getHdScheduleList(); // 선택한 달의 일정 목록조회
    },
    calculateWeekDateArray : function () { // 검색일이나 새로운 달의 첫날 기준 주 달력 일자목록 조회.
      var selectedDate = this.calendarInfo.searchDay;
      var m = selectedDate.substr(4,2);

      if(this.calendarInfo.m != m){ // 달 달력이 다른 달이면, 해당 달의 첫날이 속한 주를 보여준다.
        selectedDate = this.calendarInfo.y + this.calendarInfo.m + "01";
      }

      var selectedDateAsDateType = this.$utils.calendar.getDateByStringDate(selectedDate);
      
      var totalWeekNum    = this.$utils.calendar.getTotalWeekNum(selectedDateAsDateType); // 넘긴 날짜(Date type)가 속한 달의 주 카운트.
      var selectedWeekNum = this.$utils.calendar.getSelectedWeekNum(selectedDateAsDateType); // 넘긴 날짜(Date type)가 속한 주의 달에서의 차수.

      var weekStartDate = this.$utils.calendar.getWeekStart(selectedDate); // 넘긴 날짜(문자열)가 속한 주의 첫날 조회.
      var arrayDate = this.$utils.calendar.getWeekDateArray(weekStartDate); // 넘긴 날짜(Date type)로 시작하는 7일 날짜 배열 조회.
			
			// console.log("arrayDate:" + arrayDate);
			// console.log("-------------------------------");

      this.calendarInfo.totalWeekNum = totalWeekNum;
      this.calendarInfo.selectedWeekNum = selectedWeekNum;
      this.arrayWeekDate = arrayDate;
    }
  },
  mounted: function() { //  인스턴스가 마운트 된 직후

    // 이번 달과 오늘.
    var today = new Date();
    var y = today.getFullYear();
    var m = today.getMonth() + 1;
    var d = today.getDate();

    var thisMon = y + this.$utils.stringUtil.pad(m);
    var thisDay = y + this.$utils.stringUtil.pad(m) + this.$utils.stringUtil.pad(d);
    
    //console.log("searchMon:" + thisMon);
    //console.log("searchDay:" + thisDay);

    this.calendarInfo.today = thisDay;

    this.calculateMonthDateArray(thisMon);

    this.params.searchMon = thisMon;
    this.getHdScheduleCountList(); // 이달의 각 날짜별 일정 카운트 조회
    this.getHdScheduleList(); // 이달의 일정 목록조회
  }
};
</script>